import { createReducer } from 'redux-act';
import actions from '../actions/branchActions';

const initialState = {
  getAllBranchesPending: false,
  getAllBranchesRes: null,
  getAllBranchesError: null,
};

/* Get All Branches Reducers */
const handleGetAllBranchesRequest = state => {
  return {
    ...state,
    ...{
      getAllBranchesPending: true,
      getAllBranchesRes: null,
      getAllBranchesError: null,
    },
  };
};
const handleGetAllBranchesSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllBranchesPending: false,
      getAllBranchesRes: payload,
      getAllBranchesError: null,
    },
  };
};
const handleGetAllBranchesError = (state, payload) => ({
  ...state,
  ...{
    getAllBranchesPending: false,
    getAllBranchesRes: null,
    getAllBranchesError: payload,
  },
});

// Clear Existing Data Store Reducers*/
const clearBranchesStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_BRANCHES_STORE':
      return {
        ...state,
        ...{
          getBranchesListPending: false,
          getBranchesListRes: null,
          getBranchesListError: null,
        },
      };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.getAllBranchesRequest]: handleGetAllBranchesRequest,
    [actions.getAllBranchesSuccess]: handleGetAllBranchesSuccess,
    [actions.getAllBranchesError]: handleGetAllBranchesError,

    [actions.handleClearBranchesStore]: clearBranchesStore,
  },
  initialState,
);